import { render, staticRenderFns } from "./OnWorkingToday.vue?vue&type=template&id=2f2e0d94"
import script from "./OnWorkingToday.vue?vue&type=script&lang=js"
export * from "./OnWorkingToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports